import React from "react";
import { i18n } from "../App";

const CountriesOptions = () => {
  /* WE TAKE THE COUNTRY LIST FROM THE TRANSLATIONS COUNTRIES FILE */
  const countries = Object.entries(
    i18n.getResourceBundle(i18n.language, "countries"),
  );
  countries.sort(function (a: any, b: any) {
    //To sort the countries deppending on the current language
    return ("" + a[1]).localeCompare(b[1]);
  });
  return (
    <>
      {countries.map((country: any) => {
        return (
          <option key={country[0]} value={country[0]}>
            {country[1]}
          </option>
        );
      })}
    </>
  );
};

const spanishRegions = [
  "Andalucía",
  "Aragón",
  "Asturias",
  "Islas Baleares",
  "País Vasco",
  "Islas Canarias",
  "Cantabria",
  "Castilla-La Mancha",
  "Castilla y León",
  "Catalunya",
  "Extremadura",
  "Galicia",
  "Comunidad de Madrid",
  "Región de Murcia",
  "Navarra",
  "La Rioja",
  "Comunidad Valenciana",
  "Ceuta",
  "Melilla",
];

const SpanishRegionsOptions = () => {
  const sortedRegions = [...spanishRegions].sort((a, b) => a.localeCompare(b));

  return (
    <>
      {sortedRegions.map((region) => (
        <option key={region} value={region}>
          {region}
        </option>
      ))}
    </>
  );
};

export { CountriesOptions, SpanishRegionsOptions };
